module.exports = __webpack_public_path__ + "img/historia.699bd2d3.jpg";